import type State from './State'
import allNumberKeys from './allNumberKeys'

const namedKeys = {
  ArrowDown: 40,
  ArrowRight: 39,
  ArrowUp: 38,
  ArrowLeft: 37,
  Backspace: 8,
  Delete: 46,
  Tab: 9,
  Shift: 16,
  Escape: 27,
}

const APKeys = {
  AM: 65,
  PM: 80,
}

function handleTab(state: State, e: React.KeyboardEvent) {
  const backwardAndFirst = e.shiftKey && state.isHrs
  const isLastSegment = state.isTimeFormat24H ? state.isMinute : state.isMeridiem
  const forwardAndLast = !e.shiftKey && isLastSegment

  if (!backwardAndFirst && !forwardAndLast) {
    e.preventDefault()

    if (e.shiftKey) {
      state.prev()
    } else {
      state.next()
    }
  }
}

export default function onKeyDown(state: State, e: React.KeyboardEvent) {
  const isEnterKey = e.which === 13

  if (isEnterKey) return true

  const isNumberKey = allNumberKeys.includes(e.which)
  const isAPKey = Object.values(APKeys).includes(e.which)
  const isNamedKey = Object.values(namedKeys).includes(e.which)

  const isArrowKey = [
    namedKeys.ArrowDown,
    namedKeys.ArrowRight,
    namedKeys.ArrowUp,
    namedKeys.ArrowLeft,
  ].includes(e.which)

  const isDeleteKey = [namedKeys.Delete, namedKeys.Backspace].includes(e.which)

  const shouldPreventDefault = !isNamedKey || isArrowKey || isNumberKey || isDeleteKey

  if (shouldPreventDefault) e.preventDefault()

  if (isAPKey) e.which === APKeys.AM ? state.changeToAM() : state.changeToPM()

  if (isNumberKey) state.write(e.which)

  if (isDeleteKey && !state.isMeridiem) state.clear()

  switch (e.which) {
    case namedKeys.ArrowRight:
      state.next()
      break

    case namedKeys.ArrowLeft:
      state.prev()
      break

    case namedKeys.ArrowUp:
      state.nudge(1)
      break

    case namedKeys.ArrowDown:
      state.nudge(-1)
      break

    case namedKeys.Escape:
      state.reset()
      break

    case namedKeys.Tab:
      handleTab(state, e)
      break
  }
}
